import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { PROJECT_CATEGORIES } from "../../data/portfolio";
import { usePublicCityLinks } from "../../lib/werkgebied";

// Interne links: gebruikte producten, de lokale pagina (alleen als die online staat) en door beheer toegevoegde links.
export const ProjectLinks = ({ p }) => {
  const city = usePublicCityLinks().find((c) => c.slug === p.city_slug);
  const links = [
    ...PROJECT_CATEGORIES.filter((c) => p.categories?.includes(c.id)).map((c) => ({ href: c.href, label: c.label, hint: "Productinformatie" })),
    ...(city ? [{ href: `/kunststof-kozijnen-${city.slug}`, label: `Kozijnen in ${city.name}`, hint: "Lokale informatie", city: true }] : []),
    ...(p.related_links || []).map((l) => ({ ...l, hint: "Lees ook" })),
  ].filter((l, i, arr) => arr.findIndex((x) => x.href === l.href) === i);
  if (!links.length) return null;
  return (
    <section aria-labelledby="project-links-title" className="section-tight border-t border-slate-200 bg-slate-50" data-testid="project-links">
      <div className="container-tight">
        <h2 id="project-links-title" className="h2">Gebruikte producten en meer informatie</h2>
        <ul className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((l) => (
            <li key={l.href}>
              <Link to={l.href} className="card card-hover group flex h-full items-center justify-between gap-4 p-5" data-testid={`project-link-${l.href.slice(1).replace(/\//g, "-")}`}>
                <span>
                  <span className="block text-[12px] font-semibold uppercase tracking-[0.12em] text-gold">{l.hint}</span>
                  <span className="mt-1 flex items-center gap-1.5 text-[16px] font-semibold text-ink group-hover:text-maas">{l.city && <MapPin className="h-4 w-4 text-maas" aria-hidden="true" />}{l.label}</span>
                </span>
                <ArrowRight className="h-5 w-5 shrink-0 text-maas transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
